// http://stackoverflow.com/questions/18082/validate-decimal-numbers-in-javascript-isnumeric
import isArray from './is-array';

export default function isNumeric(value) {
	return !isArray(value) && (value - parseFloat(value) + 1) >= 0;
}
